import styles from './Footer.module.css';
import { Button, Chip } from '@indxsearch/systm';
import {
    Nuget, Book, User_privacy, Four_leaf_clover, Mail, Support, Github, Sunrise, Ai_agent, Feather
  } from "@indxsearch/pixl";

export default function Footer() {
    return (
        <div className={styles.wrapper}>
            <div className={styles.inside}>
                <div className={styles.containers}>
                    <div>
                        <h4>Links</h4>
                        <div className={styles.links}>
                            <Button
                                variant='ghost'
                                iconLeft={<Nuget/>}
                                href="https://www.nuget.org/packages/IndxSearchLib/"
                            >Nuget</Button>
                            <Button
                                variant='ghost'
                                iconLeft={<Github/>}
                                href="https://github.com/indxsearch"
                            >Github</Button>
                            <Button
                                variant='ghost'
                                iconLeft={<Book/>}
                                href="https://docs.indx.co"
                            >Docs</Button>
                            <Button
                                variant='ghost'
                                iconLeft={<Feather/>}
                                href="/articles"
                            >Articles</Button>
                            <Button
                                variant='ghost'
                                iconLeft={<User_privacy/>}
                                href="https://v5.docs.indx.co/gdpr"
                            >GDPR statement</Button>
                        </div>
                    </div>
                    <div>
                        <h4>API</h4>
                        <div className={styles.links}>
                            <Button
                                variant='ghost'
                                iconLeft={<Ai_agent/>}
                                href="https://skills.sh/skill-indx-search"
                            >Official AI skill</Button>
                            <Button
                                variant='ghost'
                                iconLeft={<Sunrise/>}
                                href="https://v5.docs.indx.co/csharp/overview"
                            >v5.0 C# API <Chip color="var(--lv6)" textColor="var(--lv0)">RC</Chip></Button>
                            <Button
                                variant='ghost'
                                iconLeft={<Four_leaf_clover/>}
                                href="https://docs.indx.co/api-41"
                            >v4.1 C# API</Button>
                        </div>
                    </div>
                    <div>
                        <h4>Get in touch</h4>
                        <div className={styles.links}>
                            <Button
                                variant='ghost'
                                iconLeft={<Mail/>}
                                href="mailto:post@indx.co"
                            >Send an e-mail</Button>
                            <Button
                                variant='ghost'
                                iconLeft={<Support/>}
                                href="mailto:support@indx.co"
                            >Developer support</Button>
                        </div>
                    </div>
                </div>
                <div className={styles.company}>
                    <div>
                        <p>Bionic AS</p>
                        <p>Org. nr 979&nbsp;925&nbsp;166</p>
                    </div>
                    <div>
                        <p>Factory Tøyen</p>
                        <p>Oslo, Norway</p>
                    </div>
                </div>
            </div>
        </div>
    );
}